import React, { useEffect, useMemo, useRef, useState } from "react";
import Barcode from "react-barcode";
import { useDispatch, useSelector } from "react-redux";
import { Br, Cut, Printer } from "react-thermal-printer";
import {
  selectPickThreeBet,
  setLotteryPlaceBet3d,
} from "../../../redux/3d_game_Slice/gameinfo3d";
import {
  selectActiveBatPrice,
  selectActiveDropDownValue,
  selectEnterQt,
  selectPanelWithInput,
  selectPointList,
  selectRenderCardArray,
  selectTimeSloat3d,
} from "../../../redux/3d_game_Slice/panelSlice";
import { selectTimeSlot, setLoaderShow } from "../../../redux/seriesSlice";
import { SocketState } from "../../../context/SocketProvider";
import moment from "moment";

function PrintComponent3d(props) {
  const dispatch = useDispatch();
  const panelWithInput = useSelector(selectPanelWithInput);
  let pointList = useSelector(selectPointList);
  const { socket } = SocketState();
  let timeSlot = useSelector(selectTimeSloat3d);
  let renderCardArry = useSelector(selectRenderCardArray);
  let activeBatPrice = useSelector(selectActiveBatPrice);
  let activeDropDownValue = useSelector(selectActiveDropDownValue);
  let enterQt = useSelector(selectEnterQt);
  let checkTimeSlots = useSelector(selectTimeSlot);

  const [apiKey, setapiKey] = useState({
    Box: "box",
    STR: "straight",
    SP: "split_pair",
    FP: "front_pair",
    BP: "back_pair",
    AP: "any_two",
  });
  const mapping = { 0: "A", 1: "B", 2: "C" };
  const result = Object.keys(props?.selectedItems)
    .filter((key) => key !== "all" && props?.selectedItems[key])
    .map((key) => mapping[key])
    .join(",");

  let generateNumber = () => {
    let genrateNumber = Math.floor(Math.random() * (999 - 100 + 1) + 100);
    let generateObjNumber = {
      number: genrateNumber,
      betType: activeDropDownValue,
      rateValue: activeBatPrice,
    };
    return generateObjNumber;
  };

  const placeBat = () => {
    dispatch(setLoaderShow(true));
    let selectTimeFilter = [];
    JSON.parse(JSON.stringify(timeSlot)).forEach((time) => {
      if (time.select) {
        selectTimeFilter.push(time.time);
      }
    });

    let generateArray = [];

    for (let index = 0; index < enterQt; index++) {
      let obj = generateNumber();
      generateArray.push(obj);
    }

    let card_details = {};
    let mergeArray = [...renderCardArry, ...generateArray];
    mergeArray.forEach((card) => {
      const betTypeKey = apiKey[card.betType] || "straight";
      if (!card_details[betTypeKey]) {
        card_details[betTypeKey] = {};
      }

      if (card_details[betTypeKey][card.number]) {
        card_details[betTypeKey][card.number] += activeBatPrice;
      } else {
        card_details[betTypeKey][card.number] = activeBatPrice;
      }
    });

    const mobile_number = localStorage.getItem("mobile_number") ?? null;
    let data = {
      en: "PICK_THREE_PLACE_BET",
      data: {
        advance_bet: checkTimeSlots.length ? true : false,
        advance_bet_times: checkTimeSlots.length ? checkTimeSlots : "",
        card_details,
        // series_type: result,
        mobile_number,
      },
    };

    // console.log(data)
    socket?.emit("req", data);

    localStorage.removeItem("mobile_number");
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F6") {
        event.preventDefault();
        placeBat();
      }
    };

    const handleWhatsappPlaceBet3d = () => {
      placeBat();
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("whatsappPlaceBet3d", handleWhatsappPlaceBet3d);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener(
        "whatsappPlaceBet3d",
        handleWhatsappPlaceBet3d
      );
    };
  }, [placeBat]);

  return (
    <>
      <button
        className=" btn-hover btn33"
        onClick={placeBat}
        id="printBtn"
        style={{
          width: "100%",
          height: "50px",
          color: '#000',
          background: "#98ff66",
          border: " #000 solid 1px",
        }}
      >
        <span className="font-bold">BUY-F6</span>
      </button>
      <div
        className="printContainer"
        id="printContainer3d"
        style={{ display: "none" }}
      >
        <Content selectedItems={props.selectedItems} />
      </div>
    </>
  );
}

let qty = 0;

let Content = ({ selectedItems }) => {
  const dispatch = useDispatch();
  let pickThreeBet = useSelector(selectPickThreeBet);
  const [printObj, setPrintObj] = useState({});
  const [newPrintObj, setNewPrintObj] = useState([]);
  const contentTag = useRef();
  const [labels, setlabels] = useState({
    box: "Box",
    straight: "STR",
    split_pair: "SP",
    front_pair: "FP",
    back_pair: "BP",  
    any_two: "AP",
  });
  const mapping = { 0: "A", 1: "B", 2: "C" };
  const result = Object.keys(selectedItems)
    .filter((key) => key !== "all" && selectedItems[key])
    .map((key) => mapping[key])
    .join(",");

  const groupedBets = useMemo(() => {
    const groups = {};
    newPrintObj.forEach((bet) => {
      const seriesArray = result.split(",");
      seriesArray.forEach((series) => {
        if (!groups[bet.type]) {
          groups[bet.type] = [];
        }
        groups[bet.type].push({
          number: bet.name,
          value: bet.value,
          series: series,
        });
      });
    });
    return groups;
  }, [newPrintObj, result]);

  useEffect(() => {
    if (pickThreeBet) {
      let { card_details } = pickThreeBet;
      let obj = {};
      let newObj = [];
      Object.keys(card_details).map((key) => {
        Object.keys(card_details[key]).map((card) => {
          qty += 1;
          if (obj[key]) {
            obj[key].totalCount += 1;
            obj[key].totalValue += card_details[key][card];
            obj[key].seriesAllfield = [
              ...obj[key].seriesAllfield,
              { name: card, value: card_details[key][card], type: key },
            ];
            newObj.push({
              name: card,
              value: card_details[key][card],
              type: key,
            });
          } else {
            newObj.push({
              name: card,
              value: card_details[key][card],
              type: key,
            });
            obj[key] = {
              totalCount: 1,
              totalValue: card_details[key][card],
              multiply: card_details[key][card],
              seriesAllfield: [
                { name: card, value: card_details[key][card], type: key },
              ],
            };
          }
        });
      });
      setPrintObj(obj);
      setNewPrintObj(newObj);
    }
  }, [pickThreeBet]);

  useEffect(() => {
    if (!pickThreeBet || pickThreeBet.mobile_number) return;
    if (Object.keys(printObj).length === 0) return;

    let place_bet = JSON.parse(JSON.stringify(pickThreeBet));
    let otherDetails = pickThreeBet;

    // 🧩 Ensure bet_details exists (sometimes missing for single ticket)
    if (!Array.isArray(place_bet.bet_details) || place_bet.bet_details.length === 0) {
      place_bet.bet_details = [
        {
          ticket_id: place_bet.ticket_id,
          deal_date: place_bet.deal_date,
          deal_time: place_bet.deal_time,
        },
      ];
    }

    // ✅ For ADVANCE BET (all tickets on one page)
    if (place_bet?.is_advance) {
      let printWindow = window.open("", "_blank");
      if (!printWindow) return;
      printWindow.document.open();
      printWindow.document.write(`
      <html>
        <head>
          <title>Advance Ticket</title>
          <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet">
          <script src="../JsBarcode.all.min.js"></script>
          <style>
            body {
              font-family: 'Roboto', sans-serif;
              margin: 0;
              padding: 0;
              font-size: 14px;
              color: #000;
              font-weight: bold;
            }
            .receipt-container { width: 250px; }
            .receipt-header { text-align: left; padding-bottom: 5px; }
            .receipt-header h2 { margin: 0; font-size: 14px; }
            .receipt-header p { margin: 0; font-size: 10px; color: #555; }
            .receipt-body { line-height: 1.4; }
            .receipt-body p { margin: 2px 0; }
            .tagline { font-style: italic; font-size: 11px; color: #444; }
            .line { border-bottom: 1px dashed #000; }
          </style>
        </head>
        <body>
    `);

      place_bet.bet_details.forEach((bet) => {
        const scanerId = document.getElementById(`ticket${bet.ticket_id}`);
        if (!scanerId || !contentTag.current) return;
        scanerId.style.display = "block";

        contentTag.current.innerHTML = `
        <div class="receipt-container">
          <div class="receipt-header">
            <h2>RajWinSkill Lotto 3D</h2>
            <p>(Ticket valid for 10 Days)</p>
       ${
        localStorage.getItem('is_gst') === "true"
          ? `<p>GST Nos : ${localStorage.getItem('gst')}</p>`
          : ""
      }
          </div>
          <div class="receipt-body">
            <p class="tagline">Amusement Only, 3D Game</p>
            <p><strong>Game Date:</strong> ${otherDetails?.deal_date ?? bet?.deal_date}</p>
            <p><strong>Game Time:</strong> ${bet.deal_time}</p>
            <p><strong>Game ID:</strong> ${otherDetails?.game_id}</p>
            <p><strong>Operator ID:</strong> ${place_bet?.user_name} ($)</p>
            <p><strong>Total Selected Spots:</strong> ${place_bet?.total_bet_amount / 10}</p>
            <p><strong>Total Point:</strong> ${place_bet?.total_bet_amount}</p>
          </div>
        </div>
        <div class="line"></div>
      `;

        const printHTML = document.getElementById("printContainer3d")?.innerHTML || "";
        scanerId.style.display = "none";
        printWindow.document.write(printHTML);
      });

      printWindow.document.write(`</body></html>`);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 400);
    }

    // ✅ NORMAL SINGLE PRINT
    else {
      // console.log("place_Bet", place_bet);
      place_bet.bet_details.forEach((bet) => {
        try {
          const scanerId = document.getElementById(`ticket${bet.ticket_id}`);
          if (!scanerId || !contentTag.current) {
            console.warn("Ticket element not found for", bet.ticket_id);
            return;
          }

          scanerId.style.display = "block";
          contentTag.current.innerHTML = `
          <div class="receipt-container">
            <div class="receipt-header">
              <h2> RajWinSkill Lotto 3D</h2>
              <p>(Ticket valid for 10 Days)</p>
              ${
        localStorage.getItem('is_gst') === "true"
          ? `<p>GST No : ${localStorage.getItem('gst')}</p>`
          : ""
      }
            </div>
            <div class="receipt-body">
              <p class="tagline">Amusement Only, 3D Game</p>
              <p><strong>Game Date:</strong> ${otherDetails?.deal_date ?? bet?.deal_date}</p>
              <p><strong>Game Time:</strong> ${bet.deal_time}</p>
              <p><strong>Game ID:</strong> ${otherDetails?.game_id}</p>
              <p><strong>Operator ID:</strong> ${place_bet?.user_name} ($)</p>
              <p><strong>Total Selected Spots:</strong> ${place_bet?.total_bet_amount / 10}</p>
              <p><strong>Total Point:</strong> ${place_bet?.total_bet_amount}</p>
            </div>
          </div>
        `;

          const printContainer3d = document.getElementById("printContainer3d")?.innerHTML || "";
          scanerId.style.display = "none";

          const newWin = window.open("", "_blank");
          if (!newWin) return;
          newWin.document.open();
          newWin.document.write(`
          <html>
            <head>
              <title> 3D</title>
              <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet">
              <script src="../JsBarcode.all.min.js"></script>
              <style>
                body { font-family: 'Roboto', sans-serif; margin: 0; padding: 0; font-size: 14px; color: #000; font-weight: bold; }
                .receipt-container { width: 250px; }
                .receipt-header { text-align: left; border-bottom: 1px dashed #000; padding-bottom: 5px; }
                .receipt-header h2 { margin: 0; font-size: 14px; }
                .receipt-header p { margin: 0; font-size: 10px; color: #555; }
                .receipt-body { line-height: 1.4; }
                .receipt-body p { margin: 2px 0; }
                .tagline { font-style: italic; font-size: 11px; color: #444; }
              </style>
            </head>
            <body>${printContainer3d}</body>
          </html>
        `);
          newWin.document.close();
          newWin.focus();
          setTimeout(() => {
            newWin.print();
            newWin.close();
          }, 300);
        } catch (error) {
          console.error("Print error:", error);
        }
      });
    }

    dispatch(setLotteryPlaceBet3d(null));
  }, [printObj]);

  if (!Object.keys(printObj).length) return null;

  return (
    <>
      <Printer type="epson" characterSet="korea" className="line">
        <div
          className="printArea"
          id="prepandContent"
          style={{ width: "58mm", color: "#000" }}
        >
          <div id="invoice" style={{ width: "58mm", padding: "10px" }}>
            <div id="invoice-POS">
              <div id="invoice" className="pruint2" style={{ width: "58mm" }}>
                <div ref={contentTag}></div>
                <div id="bot">
                  {Object.entries(groupedBets).map(([type, bets]) => {
                    const chunks = [];
                    for (let i = 0; i < bets.length; i += 3) {
                      chunks.push(bets.slice(i, i + 3));
                    }
                    return (
                      <div
                        key={type}
                        style={{
                          width: "58mm",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                          {labels[type]}:
                        </div>
                        {chunks.map((chunk, idx) => (
                          <div
                            key={idx}
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            {chunk.map((bet, i) => (
                              <span key={i} style={{ marginRight: "10px" }}>
                                {bet.number}
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                  }}
                                >
                                  *
                                </span>
                                {bet.value / 10}
                              </span>
                            ))}
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {!pickThreeBet?.bet_details && pickThreeBet?.ticket_id && (
              <div id={`ticket${pickThreeBet?.ticket_id}`}>
                <Barcode
                  value={pickThreeBet?.ticket_id}
                  width={1}
                  height={40}
                  displayValue={false}
                  marginTop={5}
                />
                <p
                  style={{
                    marginTop: 5,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {pickThreeBet?.ticket_id}
                </p>
              </div>
            )}

            {pickThreeBet?.bet_details &&
              pickThreeBet?.bet_details.map((details, index) => (
                <div
                  key={index}
                  id={`ticket${details.ticket_id}`}
                  style={{ display: "none" }}
                >
                  <Barcode
                    value={details.ticket_id}
                    width={1}
                    height={40}
                    displayValue={false}
                    marginTop={5}
                  />
                  <p
                    style={{
                      marginTop: 5,
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {details.ticket_id}
                  </p>
                </div>
              ))}
          </div>
        </div>

        {/* ✅ Only Cut when not advance */}
        {!pickThreeBet?.is_advance && <Cut />}
      </Printer>
    </>
  );
};

export default PrintComponent3d;
